import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Save } from '@material-ui/icons';
import Form from 'component/Form/FormTwoColumns'
import Mensaje from '../../../../component/MensajeElement/index'
import ApiServices from 'service/ApiServices';
import Alert from "react-s-alert"
import UserAccount from 'page/Security/Login/FormElements/UserAccount';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    "&>h6":{
        fontSize: "1.5rem",
    }
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  button:{
    "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)",
    "border":"0px", "borderRadius":"3",
    "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white",
    width: 200,
    marginRight: 15,
    marginBottom: 10,
    textAlign: 'center',
    '@media (max-width:768px)':{ //ipad
        width: '100%',
    },
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
    <Typography variant="h6">{children}</Typography>
    {onClose ? (
      <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
      <CloseIcon />
      </IconButton>
    ) : null}
    </MuiDialogTitle>
  ); 
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

// PROPS
// HANDLECLOSE, OPEN, ESTATUS USUARIO
export default function ChangePhoneNumber(props) {
  const [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''});
  const [open, setOpen] = useState(false);
  const [elements,setElements] = useState({
    phoneNumber: {
        idelement: "phoneNumber",
        value: props.phoneNumber || "",
        label: "Teléfono *",
        validators: ["required"],
        infoMessages: ["De 8 a 12 dígitos númericos, sin letras, caracteres especiales"],
        errorMessages: ["De 8 a 12 dígitos, sin espacios al inicio y final"],
        isError: false,
        elementType: "inputPhone",
        // useStateHook: setTelefonoValue,
        minLength: 8,
        maxLengthTwo: 12,
        key: 30,
        keys: [30, 31],
        inicialCountry:'gt',
        // onlyCountries:['gt'],
        enableSearch: true,
        showDropdown: false,
        margin: `40px 40px`
    },
  });

  const closeModalAndBack = () => {
    props.handleClose()
  }

  const UpdatePhoneNumber = async (data) =>{
    let updateElement  = {id: props.userId, phoneNumber: data.phoneNumber };
    let userAccount = new UserAccount()
    try{
      const response = await ApiServices.userSecurity.changePhoneNumber(updateElement);
      if (response.error==!null){
        setOpen(true)
        setMensaje({tipoError:"error", tipoMensaje:response.error.message})
      }else{
        await userAccount.setCurrentUser();
        props.Set_current_user(userAccount.getCurrentUser())
        setOpen(true)
        setMensaje({tipoError:"success", tipoMensaje:'¡BIEN! Contraseña actualizada correctamente.'})
        elements.phoneNumber.value="";
        closeModalAndBack()
      }
    }catch(exception){
      (exception.status===404) ? 
        Alert.error("No se encontró el método"): Alert.error(exception.message)
    }
}

  const [buttonList,setButtonList]= useState({
    "next":{
      "label":"Actualizar",
      "icon": <Save />,
      "callback":UpdatePhoneNumber,
      "loading":false,
      "size":"medium",
      "color":"#fff", 
      "background":"linear-gradient(130deg, rgb(6, 107, 189) 30%, rgb(30, 136, 229) 90%) repeat scroll 0% 0% ",
    },
  });

  const handClose = (event, reason) =>{
    if (reason === 'clickaway') {return ;}
    setOpen(false)
  }

  return (
    <div>
      <Dialog 
        onClose={() =>closeModalAndBack} 
        aria-labelledby="customized-dialog-title"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        open={props.open}
        maxWidth={"xs"}
        style={{borderRadius: 20}}
      >
        <DialogTitle 
          id="customized-dialog-title" 
          onClose={() =>closeModalAndBack()}
          style={{
            width: '100%',
            fontSize: "1.8rem",
            fontWeight: 600,
            // textAlign: 'center',
            color: '#4b4b4b',
          }}
        >
          Actualizar contacto
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom style={{
            width: '100%',
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: '27px',
            color: '#545454',
            padding: 18
          }}>
              * Exclusivamente para uso de autenticación y/o verificación, esta opción no actualiza ningún dato en Padrón Electoral
          </Typography>
          <Form
            elements={elements}
            buttonList={buttonList}
            style={{background: "red"}}
          />
        </DialogContent>
      </Dialog>
      <Mensaje type={mensaje.tipoError} content={mensaje.tipoMensaje} open={open} handClose={handClose} />
    </div>
  );
}


